import TotalPrice from "./TotalPrice";
import checkoutBtnBg from "../../assets/images/cart-btn-bg.png";
import { useState } from "react";
import { useCart } from "../../hooks/use-cart";
import ShoppingCart from "./ShoppingCart";
import { useAudioEffects } from "../../../../hooks/use-audio-effects";
import clickSound from "../../../../assets/audio/click.wav";

interface Props {
  className?: string;
  /**  currency: string;
  total: number; */ // its better to use useCartt inside this component to not render entire layout in tuning.tsx
}

const CartOverview = ({ className = "" }: Props) => {
  const { total, currency, items } = useCart();
  const { playEffect } = useAudioEffects();
  const [openShoppingCart, setOpenShoppingCart] = useState<boolean>(false);

  return (
    <div className={`${className}`}>
      <TotalPrice total={total} currency={currency} />
      <button
        onClick={() => {
          setOpenShoppingCart(true);
          playEffect(clickSound);
        }}
        title="Open shopping cart"
        className="relative rounded-md overflow-hidden min-h-[30px] flex items-center justify-center text-center text-white w-full py-2 mt-2 hover:opacity-80 active:scale-95 transition"
      >
        <img
          src={checkoutBtnBg}
          alt="s"
          className="absolute top-0 left-0 w-full h-full z-[-1g"
        />
        <p>Open Shopping Cart</p>
      </button>

      <ShoppingCart
        isOpen={openShoppingCart}
        items={items}
        onClose={() => setOpenShoppingCart(false)}
        width="w-[550px]"
        height="h-[750px]"
      />
    </div>
  );
};

export default CartOverview;
